// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The editor tracker token.
 */
export const IEditorTracker = new Token('@jupyterlab/fileeditor:IEditorTracker', `A widget tracker for file editors.
  Use this if you want to be able to iterate over and interact with file editors
  created by the application.`);
/**
 * The editor widget factory token.
 */
export const IEditorWidgetFactory = new Token('@jupyterlab/fileeditor:IEditorWidgetFactory', 'A factory for creating file editors.');
//# sourceMappingURL=tokens.js.map